<template>
  <div class="ecommerce_product_select_category">
    <v-btn
      small
      class="ma-1"
      :color="currentCategory != 'all' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != 'all'"
      @click="onChangeCategory('all')"
    >
      {{$t('All')}}
      <template v-if="stat.all > 0">({{stat.all}})</template>
    </v-btn>
    <v-btn
      small
      class="ma-1"
      :color="currentCategory != 'soldout' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != 'soldout'"
      @click="onChangeCategory('soldout')"
    >
      {{$t('Sold out')}}
      <template v-if="stat.soldout > 0">({{stat.soldout}})</template>
    </v-btn>
    <v-btn
      small
      class="ma-1"
      :color="currentCategory != 'sales' ? 'grey' : 'primary'"
      depressed
      :outline="currentCategory != 'sales'"
      @click="onChangeCategory('sales')"
    >
      {{$t('Sale')}}
      <template v-if="stat.sales > 0">({{stat.sales}})</template>
    </v-btn>
    <template v-for="(category,index) in categorylist">
      <v-btn
        small
        class="ma-1"
        :color="currentCategory != category.id ? 'grey' : 'primary'"
        depressed
        :outline="currentCategory != category.id"
        :key="'category_'+index"
        @click="onChangeCategory(category.id)"
      >{{category.name}}</v-btn>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    categories: Array,
    stat: {
      default: {
        all: 0,
        soldout: 0,
        sales: 0
      },
      type: Object
    }
  },
  data: function() {
    return {
      categorylist: this.categories,
      currentCategory: this.value
    }
  },
  methods: {
    onChangeCategory: function(index) {
      let vm = this
      vm.currentCategory = index
      vm.$emit('input', vm.currentCategory)
    }
  },
  watch: {
    value: function() {
      this.currentCategory = this.value
    },
    categories: function() {
      this.categorylist = this.categories
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ananda/FilterCategory.vue